<template>
  <GeneralDashboard
      :dashboard-title="dashboardTitle"
      @load-data="getDataToChart"
      ref="dashboard"
      :config="config"
      :dashlet-config="dashletConfig"
      :label-with="$tr('color-version-confirmed-status','Confirmed status')"
      :label-without="$tr('color-version-without-status','Without status')"
      :uuid="uuid"
      :color-good="colorGood"
      :color-bad="colorBad"
      :id="id"
  ></GeneralDashboard>
</template>

<script>
import DashletsRpc from "@/DashletsRpc";
import DashletConfig from "@/server/com/silkplm/engine/dashboards/DashletConfig";
import GeneralDashboard from "@/components/dashlets/GeneralDashboard.vue";

export default {
  name: "ColorVersionConfirmed",
  components: {GeneralDashboard},

  methods: {
    async getDataToChart(selectedSeasonId, selectedMerchantId) {
      let start = performance.now();
      const data = await DashletsRpc.ColorVersionConfirmed.getIntegersColorVersionsWithConfirmedStatus(selectedSeasonId, selectedMerchantId);
      await this.$refs.dashboard.getDataToChart(data);
      // console.log(`P0: ${(performance.now() - start) / 1000} ms`);
    }
  },

  props: {
    uuid: {type: String, required: true},
    dashletConfig: {type: DashletConfig},
    config: {type: Object},
    id: {type: Number, required: true}
  },

  data() {
    return {
      dashboardTitle: $tr('color-version-approval-status-title', 'How Many Color Versions in the Season are Confirmed?'),
      colorGood: 'rgb(0, 128, 0)',
      colorBad: 'rgb(255, 99, 132)'
    };
  }
};
</script>

<style scoped>
</style>